import React, {useMemo} from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../../../components/ui/Header";
import Icon from '../../../components/AppIcon';
import Image from "../../../components/AppImage";
import blogs from "../../../data/blogs";
import Footer from "../../../components/ui/Footer";

const BlogDetail = () => {
    const { id } = useParams();
    const blogId = parseInt(id, 10);

    const article = useMemo(() => blogs.find((c) => c.id === blogId), [blogId]);

    if (!article) {
        return (
            <div className="min-h-screen bg-warm-parchment flex flex-col">
                <Header />
                <main className="flex-1 flex items-center justify-center">
                    <div className="text-center">
                        <h2 className="text-2xl font-bold mb-4">Artículo no encontrado</h2>
                        <Link
                            to="/author-s-desk-articles-commentary"
                            className="text-primary hover:text-accent"
                        >
                            ← Volver al Blog
                        </Link>
                    </div>
                </main>
                <Footer/>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-warm-parchment flex flex-col">
            <Header />

            <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="mb-6">
                    <Link
                        to="/author-s-desk-articles-commentary"
                        className="inline-flex items-center text-primary hover:text-accent mb-4"
                    >
                        <Icon name="ArrowLeft" size={16} className="mr-2" />
                        Volver al Blog
                    </Link>
                </div>

                <article>
                    <div className="mb-6">
                        <Image
                            src={article.image}
                            alt={article.title}
                            className="w-full rounded-lg literary-shadow"
                        />
                    </div>

                    <div className="mb-4 flex items-center space-x-3">
            <span className="px-3 py-1 bg-primary text-primary-foreground rounded-full text-sm">
              {article.category}
            </span>
                        <span className="text-sm text-scholarly-gray">
              {new Date(article.date).toLocaleDateString("es-ES", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
              })}
            </span>
                    </div>

                    <h1 className="font-headline text-3xl font-bold text-primary mb-6">
                        {article.title}
                    </h1>

                    <div className="prose prose-lg max-w-none prose-headings:font-headline prose-headings:text-primary prose-p:text-scholarly-gray prose-a:text-primary prose-a:no-underline hover:prose-a:underline">
                        {article.content}
                    </div>

                    <div className="mt-8">
                        <iframe
                            className="w-full aspect-video rounded-lg literary-shadow"
                            src={article.videoUrl}
                            title={article.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </article>
            </main>

            <Footer />
        </div>
    );
};

export default BlogDetail;
